import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _34335672 = () => interopDefault(import('../src/pages/baggage-details/index.vue' /* webpackChunkName: "pages/baggage-details/index" */))
const _9a4f25c8 = () => interopDefault(import('../src/pages/booking-products/index.vue' /* webpackChunkName: "pages/booking-products/index" */))
const _376347c6 = () => interopDefault(import('../src/pages/callback.vue' /* webpackChunkName: "pages/callback" */))
const _12b3aebd = () => interopDefault(import('../src/pages/downloads/index.vue' /* webpackChunkName: "pages/downloads/index" */))
const _27b4f514 = () => interopDefault(import('../src/pages/guests-details/index.vue' /* webpackChunkName: "pages/guests-details/index" */))
const _64a606b8 = () => interopDefault(import('../src/pages/login.vue' /* webpackChunkName: "pages/login" */))
const _02532022 = () => interopDefault(import('../src/pages/maintenance.vue' /* webpackChunkName: "pages/maintenance" */))
const _6db20bb5 = () => interopDefault(import('../src/pages/manage-booking/index.vue' /* webpackChunkName: "pages/manage-booking/index" */))
const _20672649 = () => interopDefault(import('../src/pages/my-profile.vue' /* webpackChunkName: "pages/my-profile" */))
const _b3776316 = () => interopDefault(import('../src/pages/search-booking.vue' /* webpackChunkName: "pages/search-booking" */))
const _5679ccf3 = () => interopDefault(import('../src/pages/downloads/error.vue' /* webpackChunkName: "pages/downloads/error" */))
const _d334949e = () => interopDefault(import('../src/pages/downloads/ticket.vue' /* webpackChunkName: "pages/downloads/ticket" */))
const _0489bf65 = () => interopDefault(import('../src/pages/guests-details/questionnaire.vue' /* webpackChunkName: "pages/guests-details/questionnaire" */))
const _2ec9e16a = () => interopDefault(import('../src/pages/manage-booking/cancel/index.vue' /* webpackChunkName: "pages/manage-booking/cancel/index" */))
const _6d37182a = () => interopDefault(import('../src/pages/manage-booking/update-details.vue' /* webpackChunkName: "pages/manage-booking/update-details" */))
const _0bee47d0 = () => interopDefault(import('../src/pages/manage-booking/cancel/receipt.vue' /* webpackChunkName: "pages/manage-booking/cancel/receipt" */))
const _ca0338be = () => interopDefault(import('../src/pages/index.vue' /* webpackChunkName: "pages/index" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/baggage-details",
    component: _34335672,
    name: "baggage-details"
  }, {
    path: "/booking-products",
    component: _9a4f25c8,
    name: "booking-products"
  }, {
    path: "/callback",
    component: _376347c6,
    name: "callback"
  }, {
    path: "/downloads",
    component: _12b3aebd,
    name: "downloads"
  }, {
    path: "/guests-details",
    component: _27b4f514,
    name: "guests-details"
  }, {
    path: "/login",
    component: _64a606b8,
    name: "login"
  }, {
    path: "/maintenance",
    component: _02532022,
    name: "maintenance"
  }, {
    path: "/manage-booking",
    component: _6db20bb5,
    name: "manage-booking"
  }, {
    path: "/my-profile",
    component: _20672649,
    name: "my-profile"
  }, {
    path: "/search-booking",
    component: _b3776316,
    name: "search-booking"
  }, {
    path: "/downloads/error",
    component: _5679ccf3,
    name: "downloads-error"
  }, {
    path: "/downloads/ticket",
    component: _d334949e,
    name: "downloads-ticket"
  }, {
    path: "/guests-details/questionnaire",
    component: _0489bf65,
    name: "guests-details-questionnaire"
  }, {
    path: "/manage-booking/cancel",
    component: _2ec9e16a,
    name: "manage-booking-cancel"
  }, {
    path: "/manage-booking/update-details",
    component: _6d37182a,
    name: "manage-booking-update-details"
  }, {
    path: "/manage-booking/cancel/receipt",
    component: _0bee47d0,
    name: "manage-booking-cancel-receipt"
  }, {
    path: "/",
    component: _ca0338be,
    name: "index"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
